<template>

  <div>

    <TypeSpotFolderDialog @onSubmit="onTypeSpotFolderDialog"/>

    <t-dialog-form :generalErrors="generalErrors" large :title="t(command) + ' Pavimento'"
                   tabs
                   :set-tab-index="setTabIndex"
                   :ok-text="t(command) + ' Pavimento'" @show="showModal" @hidden="onClose" :busy="busy" :id="id"
                   :status="status" :command="command"
                   ref="dialog_form" @onSubmit="onSubmit">

      <template #default>

        <t-form-tab title="Dados Básicos" class="border">

          <b-card-title>{{ divisionName }}</b-card-title>

          <t-input v-model="form.spotFolderId" hidden/>

          <b-row>

            <t-input v-model="form.name" cols="6" :add-error="error.name" label="Pavimento" required/>

            <t-input v-model="form.typeSpotFolderId" cols="4"
                     :options="typeSpotFolderOptions" :add-error="error.typeSpotFolderId"
                     label="Classificação" select>

              <template #no-options>
                <b-link @click="openDialogForm('modal-type-spot-folder')">Cadastrar Classificação</b-link>
              </template>

              <template #input-group-append>
                <t-button title="Adicionar Classificação" @click="openDialogForm('modal-type-spot-folder')"
                          icon-plus/>
              </template>

            </t-input>

            <t-input v-model="form.spotFolderCodeLabel"
                     v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                     :add-error="error.spotFolderCodeLabel" upper cols="2"
                     label="Cód. Pavimento"
                     help="Código inserido manualmente conforme configurado em Locais > Configurações > Parâmetros"
                     required/>

            <t-input v-model="form.spotFolderCodeLabel"
                     v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                     :add-error="error.spotFolderCodeLabel" upper cols="2"
                     fixed
                     label="Cód. Pavimento"
                     help="Código inserido automaticamente conforme configurado em Locais > Configurações > Parâmetros"
            />


          </b-row>


<!--          <div class="alert-warning p-2 mb-2">

            <div v-if="getRenderRule('MODULE_ARCH_ENABLE_SHARING_PUBLIC') === 1">

              <b-form-checkbox class="mt-2 mb-2" v-model="form.sharingEnable" switch>
                Habilitar acesso externo através de URL?
                <t-help
                    title="Utilize esta opção para possibilitar o acesso externo aos ambientes relacionados diretamente com este pavimento, possibilitando que os mesmos possam visualizar apontamentos, arquivos ou imagens que estejam marcadas como públicas."/>
              </b-form-checkbox>

              <div v-if="form.sharingEnable">
                <a v-if="!isInsert()" :href="form.sharingURL" target="_blank">{{ form.sharingURL }}</a>
                <small v-else>Link em processamento, após a inclusão será informado o link gerado.</small>
              </div>


            </div>

            <div v-else>Conta com política global de compartilhamento de locais desabilidata. Para habilitar o
              compartilhamento via Qr-code solicite a um usuário administrador.
            </div>


          </div>-->

          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <t-input-status v-model="form.status"/>

        </t-form-tab>

      </template>

      <template #out-of-form>

        <t-form-tab title="Ambientes"
                    :disabled="!relationAccessPageGeneral('place-environment')" lazy>

          <EnterpriseEnvironment v-if="form.spotFolderId > 0" :foreign-key="form.spotFolderId" :spotFolder="form.name"/>
        </t-form-tab>

        <t-form-tab title="Planta Pavimento" class="border" :disabled="!relationAccessPageGeneral('place-spot-folder-file')"
                    lazy>

          <SpotFolderFile type-unique-image category-unique="FP" detail-unique="Planta Baixa"
                          :foreign-key="form.spotFolderId"/>


        </t-form-tab>

        <t-form-tab title="Arquivos" class="border" :disabled="!relationAccessPageGeneral('place-spot-folder-file')"
                    lazy>

          <t-form-card class="border" title="Imagens variadas">
            <SpotFolderFile type-image :foreign-key="form.spotFolderId"/>
          </t-form-card>

          <t-form-card class="border" title="Arquivos variadas">
            <SpotFolderFile :foreign-key="form.spotFolderId"/>
          </t-form-card>

        </t-form-tab>

        <t-form-tab title="Comentários" class="border" :disabled="validationCommentOption === 0" lazy>
          <Comment :foreign-key="userAuth.currentPage.pageId" :relation-key="form.spotFolderId"
                   enable-sharing
                   disabled-category
                   disabled-keyword/>
        </t-form-tab>


      </template>


    </t-dialog-form>

  </div>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import MaskMinuteType from "@/model/types/resource/MaskMinuteType";
import SettingType from "@/model/types/resource/SettingType";
import SpotFolderFile from "@/views/modules/place/SpotFolderFile";
import Comment from "@/views/modules/general/Comment";
import EnterpriseDivisionService from "@/services/modules/place/EnterpriseDivision.service";
import TypeSpotFolderService from "@/services/modules/place/TypeSpotFolder.service";
import TypeSpotFolderDialog from "@/views/modules/place/TypeSpotFolderDialog";
import EnterpriseEnvironment from "@/views/modules/place/EnterpriseEnvironment";


export default {
  name: 'SpotFolderDialog',
  mixins: [pageDialogFormMixin],
  components: {tDialogForm, SpotFolderFile, Comment, TypeSpotFolderDialog, EnterpriseEnvironment},
  data() {
    return {
      SettingType,
      MaskMinuteType,
      id: "modal-place-stop-folder",
      path: "place/spot-folder", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "spotFolderId",
      foreignKeyColumn: "enterpriseDivisionId", //Utilizar quando usar Tabs com outros componentes
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      form: {
        spotFolderId: this.spotFolderId,
        enterpriseDivisionId: this.foreignKey,
        enterpriseId: this.enterpriseId,
        spotFolderNumber: 0,
        spotFolderCodeLabel: "",
        typeSpotFolderId: 0,
        name: "",
        childSpotFolderId: 0,
        degree: 0,
        sharingEnable: false,
        sharingURL: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        spotFolderCodeLabel: "",
        typeSpotFolderId: "",
        name: ""
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      noOptionAddInner: "",//Criado outro, pois já está em um dialogo com uso do noOptionAdd
      divisionOptions: [],
      typeSpotFolderOptions: [],
      validationCommentOption: 0,
      modeCodeLabel: "",
    }
  },
  props: {
    spotFolderId:{
      type: Number,
      default:0,
    },
    enterpriseId: {
      type: Number,
      required: true,
    },
    divisionName: {
      type: String,
      default: ""
    },
    setTabIndex: {
      type: Number,
      default: 0,
    },
  },
  methods: {

    async mountedContinued() {

      await EnterpriseDivisionService.selectList(this.foreignKey).then((list) => {
        this.divisionOptions = list
      }).catch(error => this.responseError(error))

      await TypeSpotFolderService.selectList().then((list) => {
        this.typeSpotFolderOptions = list
      }).catch(error => this.responseError(error))


    },

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {


      this.busy = true

      //Limpa os campos
      this.resetModal()

      //Setar alguma informações padrão por exemplo vindo de fora
      this.form.spotFolderId = this.spotFolderId
      this.form.enterpriseDivisionId = this.foreignKey
      this.form.enterpriseId = this.enterpriseId
      this.form.sharingEnable = false
      this.form.status = 1


      this.validationCommentOption = this.getRenderRule('validationCommentOption')
      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await this.readModal(true)

    },


    async onSubmit() {

      //Validações específicas da tela
      await this.setSubmitDialogDefault()


    },

    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onTypeSpotFolderDialog(itemInserted) {

      this.form.typeSpotFolderId = itemInserted.value
      this.typeSpotFolderOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    //--------------------------------------------------------------------------------------
  },
}
</script>
